<template>
  <div>
    <record-info
      class="mb-100"
      :record="record"
      :status="status"
      is-large
    ></record-info>

    <record-status-selector
      class="mb-100"
      :record="record"
    ></record-status-selector>

    <record-temperature-buttons
      :record-id="record.id"
      v-model="record.temperature"
    ></record-temperature-buttons>

    <record-next-contact
      class="my-200"
      :record="record"
    ></record-next-contact>

    <notes-with-latest :record="record"></notes-with-latest>
  </div>
</template>

<script>
export default {
  name: "LeadBoxContacting",
  props: {
    record: {
      type: Object,
      required: true
    },
    status: {
      type: Object,
      required: true
    }
  },
};
</script>
